import React, { useState, useEffect } from "react";
import styles from "../styles/Usuarios.module.css";
import { fetchProfiles, handleNuevoUsuarioSubmit } from "../handlers/usuarios";

const NuevoUsuarioModal = ({ show, onClose, onUserAdded }) => {
  const token = localStorage.getItem("token");
  const [newUser, setNewUser] = useState({
    username: "",
    full_name: "",
    mail: "",
    profile_id: "",
    password: "",
  });
  const [message, setMessage] = useState("");
  const [profiles, setProfiles] = useState([]);

  useEffect(() => {
    if (show) {
      fetchProfiles(token, setProfiles);
      setMessage("");
      setNewUser({
        username: "",
        full_name: "",
        mail: "",
        profile_id: "",
        password: "",
      });
    }
  }, [show, token]);

  const handleChange = (e) => {
    setNewUser({ ...newUser, [e.target.name]: e.target.value });
  };

  return show ? (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <span className={styles.modalTitle}>Agregar Nuevo Usuario</span>
          <button
            className={styles.closeButton}
            onClick={onClose}
            title="Cerrar"
          >
            ×
          </button>
        </div>
        <form
          onSubmit={(e) =>
            handleNuevoUsuarioSubmit({
              e,
              newUser,
              token,
              setMessage,
              setNewUser,
              onUserAdded,
              onClose,
            })
          }
          className={styles.modalForm}
        >
          <input
            type="text"
            name="username"
            placeholder="Usuario"
            value={newUser.username}
            onChange={handleChange}
            required
            className={styles.input}
          />
          <input
            type="text"
            name="full_name"
            placeholder="Nombre completo"
            value={newUser.full_name}
            onChange={handleChange}
            required
            className={styles.input}
          />
          <input
            type="email"
            name="mail"
            placeholder="Correo"
            value={newUser.mail}
            onChange={handleChange}
            required
            className={styles.input}
          />
          <select
            name="profile_id"
            value={newUser.profile_id}
            onChange={handleChange}
            required
            className={styles.input}
          >
            <option value="" disabled>
              Perfil (obligatorio)
            </option>
            {profiles.map((profile) => (
              <option key={profile.id} value={profile.id}>
                {profile.name}
              </option>
            ))}
          </select>
          <input
            type="password"
            name="password"
            placeholder="Contraseña"
            value={newUser.password}
            onChange={handleChange}
            required
            className={styles.input}
          />
          <button type="submit" className={styles.button}>
            Guardar
          </button>
          <button
            type="button"
            className={styles.button}
            style={{ background: "#ccc", color: "#333" }}
            onClick={onClose}
          >
            Cancelar
          </button>
          {message && <p className={styles.message}>{message}</p>}
        </form>
      </div>
    </div>
  ) : null;
};

export default NuevoUsuarioModal;